<div class="dialog-container">
  <h2 mat-dialog-title>{{ 'dialog_edit_proof_title' | translate }}</h2>
  <p class="file-name-display">
    {{ 'dialog_edit_proof_file_label' | translate }} <strong>{{ data.proof.fileName }}</strong>
  </p>

  <mat-dialog-content [formGroup]="form">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ 'dialog_edit_proof_field_data' | translate }}</mat-label>
      <mat-select formControlName="justificationTypes" multiple>
        <mat-option *ngFor="let option of justificationOptions" [value]="option">{{ option | translate }}</mat-option>
      </mat-select>
      <mat-error *ngIf="form.get('justificationTypes')?.hasError('required')">{{ 'dialog_upload_justificatives_error_required' | translate }}</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ 'dialog_justificative_field_comment' | translate }}</mat-label>
      <textarea matInput formControlName="comment" rows="3"></textarea>
    </mat-form-field>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">{{ 'common_btn_cancel' | translate }}</button>
    <button mat-flat-button color="accent" [disabled]="!form.valid" (click)="onSave()">{{ 'common_btn_save' | translate }}</button>
  </mat-dialog-actions>
</div>
